import { useEffect } from 'react';
import { updateAdvertisingMenuPromoEnabled } from '../../../utils/useAdvertisingPromoEnabled';
import { AdvertisingPromoText } from '../AdvertisingPromoText/AdvertisingPromoText';
import { AdvertisingButton } from './parts/AdvertisingButton/AdvertisingButton';
import { PromoWrapper, Wrapper } from './styles';
import type { AdvertisingMenuButtonProps } from './types';

export const AdvertisingMenuButton: React.FC<AdvertisingMenuButtonProps> = ({
    text,
    target = '_blank',
    promo,
}) => {
    useEffect(() => {
        if (!promo) {
            return;
        }

        updateAdvertisingMenuPromoEnabled();
    }, [promo]);

    if (promo) {
        return (
            <PromoWrapper>
                <AdvertisingButton
                    target={target}
                    text={text}
                    textProps={{ display: { xs: 'none', lg: 'initial' } }}
                />
                <AdvertisingPromoText m={1} display={{ xs: 'none', lg: 'initial' }} />
            </PromoWrapper>
        );
    }

    return (
        <Wrapper>
            <AdvertisingButton
                target={target}
                text={text}
                textProps={{ display: { xs: 'none', lg: 'initial' } }}
            />
        </Wrapper>
    );
};
